import { StatusContainer } from "../GrandChartItem.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../../stores";
import { GrandChartStore } from "../../../../stores/grand-charts/grand-chart.store";

interface StatusProps {
	grandChart: GrandChartStore;
}

export const Status = observer(({ grandChart }: StatusProps) => {
	const {
		authStore: { userStore },
	} = useStores();

	const activeShopOrder = userStore.getActiveOrderByGrandChartId(grandChart.id);

	const hasAccess = Boolean(activeShopOrder);
	return (
		<StatusContainer isTrial={!hasAccess} durationType={activeShopOrder?.duration || null}>
			{hasAccess ? activeShopOrder?.duration : "Free plan"}
		</StatusContainer>
	);
});
